// src/components/BookingPage.js
import React, { useState } from 'react';

import AmountInput from '../modal/AmountInput';
import { Helmet } from 'react-helmet';
import {
    Container,
    Typography,
    ToggleButton,
    ToggleButtonGroup,
    TextField,
    Button,
    Box,
    Card,
    CardContent,
} from '@mui/material';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'; // Icon for the button
import Autocomplete from '../modal/AutoComplete';
import PhoneNumberField from '../modal/PhoneNumberField'
import { useAlert } from '../Alert/Alert';

import {saveCommonPackage,saveLocalPackage,saveYercaudPackage} from '../loginPageService'

import '../CSS/styles.css'

const TeriffPageForm = () => {
    // State to hold the selected trip type
    const [packageType, setPackageType] = useState('local');

    
    const {showAlert , setToken , authToken} = useAlert();

    const [loading , setLoading] = React.useState(false);


    // State for all form fields
    const [carModal, setCarModal] = useState({title:'',year:''});

    const [rentFourtyKm, setRentFourtyKm] = useState(0.0);

    const [rentEightyKm, setRentEightyKm] = useState(0.0);

    const [outStationPerKm, setOutStationPerKm] = useState(0.0);


    const [rentOneTwentyKm, setRentOneTwentyKm] = useState(0.0);


    const [waitingOneHours, setWaitingOnehours] = useState(0.0);

    const [dropYercaud, setDropYercaud] = useState(0.0);

    const [dropPackage, setDropPackage] = useState(0.0);


    const [kilometer, setKiloMeter] = useState(0);


    const [amount, setAmount] = useState(0.0);


    const [addKM, setAddKM] = useState(0);


    const [addHours, setAddHours] = useState(0);


    const [localRate, setLocalRate] = useState(0.0);

    const [packageExtraKm, setPackagExtraKm] = useState(0.0);




    // Handle form submission
    const handleSubmit = () => {
        if (packageType === 'local') {
            const formData = {
                vehicleType: carModal.title,
                firstFourtyKm: rentFourtyKm,
                secondFourtyKm: rentEightyKm,
                thirdFourtyKm: rentOneTwentyKm,
                outStationPerKm: outStationPerKm,
                waitingHours: waitingOneHours,
            };

            console.log('Form Data:', formData);
            submitLocalPackage(formData);
        }
        else if (packageType === 'yercaud') {
            const formData = {
                vehicleType: carModal.title,
                dropYercaud: dropYercaud,
                dropPackage: dropPackage,
                kilometer: kilometer,
                amount: amount,
                addKM: addKM,
                addHours: addHours,
            };

            console.log('Form Data:', formData);
        }

        else if (packageType === 'common') {
            const formData = {
                vehicleType: carModal.title,
                kilometer: kilometer,
                localRate: localRate,
                packageExtraKm: packageExtraKm
            };

            console.log('Form Data:', formData);
        }
        // Submit or process the form data here (e.g., API call)
    };
    // Handle change in trip type selection
    const handleTripTypeChange = (event, newPackageType) => {
        if (newPackageType !== null) {
            setPackageType(newPackageType);
        }
    };


    
  async function submitLocalPackage(localPackage) {

    try {
        setLoading(true);
        // Wait for the API call to complete
        const response = await saveLocalPackage(localPackage);

        // Handle the response here
        if (response.status === 200) {
          setLoading(false);
          //  if(response.data == 'connected'){
                showAlert('Login successful!', 'success');// Store token
        } else {
            showAlert('Something Wrong', 'error');
        }
    } catch (error) {
        // Handle network or other errors
        localStorage.setItem('error',error);
        console.error('Error during login:', error);
        showAlert('Login error!', 'error');
    }
}

    // Render form based on selected trip type
    const renderForm = () => {
        return (
            <Card sx={{ mt: 3, backgroundColor: '#fff', maxWidth: 600 }}>
                <Helmet>
                    <meta charset="UTF-8" />
                    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                    <meta property="og:type" content="website" />
                    <meta property="og:site_name" content="SVR Taxi Service" />
                    <meta charset="UTF-8" />
                    <meta name="viewport" content="width=device-width, initial-scale=1.0" />


                    <meta property="og:locale" content="en_IN" />
                    <meta property="og:url" content="https://svrtaxi.netlify.app/package" />
                    <meta property="og:image" content="https://svrtaxi.netlify.app/VisitingCard.jpg" />
                    <meta name="description" content="Reliable, taxi, service, in Salem, and, across India. Available 24/7 with professional drivers and affordable pricing. Book now for a comfortable journey." />
                    <meta name="keywords" content="best cab service in salem ,Salem to Yercaud Taxi Service - Affordable Rides to the Scenic Hill Station,Salem to Tirupati Taxi - Comfortable Rides to the Sacred Temple Town, Salem to Bangalore Taxi Service - Fast and Reliable City Transfers,Salem to Madurai Taxi Service - Explore the Historic City with Ease,Salem to Coimbatore Taxi Service - Quick and Safe Transportation,
Salem to Ooty Taxi Service - Scenic Rides to the Queen of Hill Stations, Salem to Kodaikanal Taxi Service - Travel to the Princess of Hill Stations , Salem to Kanyakumari Taxi Service - Journey to the Southern Tip of India , Salem to Chennai Taxi Service - Efficient Transfers to Tamil Nadu’s Capital , Salem to Oganakkal Falls Taxi Service - Explore the Stunning Waterfalls , Salem to Mettur Dam Taxi Service - Comfortable Rides to the Historic Dam , Salem to Thanjavur Taxi Service - Explore the Cultural Capital of Tamil Nadu ,taxi ,service, Salem, India, airport, transfers, intercity, travel, taxi ,booking,svr taxi,Affordable, taxi ,service ,from ,Salem, to ,Chennai,Best, outstation, cab ,service, from ,Salem ,to ,Kodaikanal,Taxi ,service ,for ,day, trips, in ,and, around, Salem,One-way ,taxi ,service ,from ,Salem ,to ,Bangalore,Book ,a, cab, for ,Salem to ,Tiruchirappalli ,trip,Salem to ,Yercaud ,cab ,service for ,family ,trips,Reliable ,24-hour, taxi, service in Salem,Taxi booking, for airport transfers, in Salem,Safe, taxi, service ,for solo ,women, travelers ,in Salem,Outstation, cab, services ,from Salem ,for business ,trips,Affordable car ,rental ,for Salem, sightseeing,Affordable ,Salem to ,Ooty, weekend, tour ,packages,Salem to ,Munnar, taxi, service with sightseeing packages,Pilgrimage, taxi service from, Salem to ,Samayapuram, Temple,
    Budget ,taxi, packages, from Salem to ,Hogenakkal, Falls,Cab service for Salem to ,Kodaikanal, honeymoon, package,Luxury, taxi service, for ,corporate ,trips, from Salem to ,Chennai,Round-trip, taxi ,service ,from Salem to, Mysore,Car, rental, with, driver, for ,outstation trips, in ,Tamil Nadu,Customized, tour packages, with taxi service in Tamil Nadu,
    Cheap, cab ,service for ,outstation trips, from Salem, best, taxi service in salem , best , taxi , service , Best taxi service in salem , Best Cab service in salem"/>
                    <meta name="author" content="SVR Taxi" />
                    {/* {    <link rel="icon" href="%PUBLIC_URL%/favicon.ico" type="image/x-icon" /> } */}

                    <meta property="og:title" content="Just call and book the ride | 8 Rs Per km in salem" />
                    <link rel="stylesheet" href="%PUBLIC_URL%/styles.css" />
                    <link rel="preconnect" href="https://fonts.googleapis.com" />
                    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
                    <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap" rel="stylesheet" />


                </Helmet>
                <CardContent>
                    <Typography variant="h1" gutterBottom sx={{ fontSize: 'larger' }}>
                        {packageType === 'local' && 'Local Package'}
                        {packageType === 'yercaud' && 'Yercaud Package'}
                        {packageType === 'common' && 'Common Package'}
                    </Typography>

                    {/* Common fields for all trip types */}

                    <Autocomplete
                        label={"Select Car Model"}
                        lookupName={"carModals"}
                        value={carModal}
                        onChange={setCarModal} // Assuming Autocomplete returns a value
                    />

                    {/* Trip-specific fields */}
                    {packageType === 'local' && (
                        <>
                            <AmountInput sx={{ marginTop: '20px' }}
                                label="40 Km 4Hrs"
                                value={rentFourtyKm}
                                onChange={setRentFourtyKm}
                            />
                            <AmountInput sx={{ marginTop: '20px' }}
                                label="80 Km 4Hrs"
                                value={rentEightyKm}
                                onChange={setRentEightyKm}
                            />
                            <AmountInput sx={{ marginTop: '20px' }}
                                label="120 Km 4Hrs"
                                value={rentOneTwentyKm}
                                onChange={setRentOneTwentyKm}
                            />
                            <AmountInput sx={{ marginTop: '20px' }}
                                label="Out Station per km"
                                value={outStationPerKm}
                                onChange={setOutStationPerKm}
                            />

                            <AmountInput sx={{ marginTop: '20px' }}
                                label="Waiting 1 Hrs"
                                value={waitingOneHours}
                                onChange={setWaitingOnehours}
                            />
                        </>
                    )}

                    {packageType === 'yercaud' && (
                        <>
                            <AmountInput sx={{ marginTop: '20px' }}
                                label="Drop Yercaud"
                                value={dropYercaud}
                                onChange={setDropYercaud}
                            />
                            <AmountInput sx={{ marginTop: '20px' }}
                                label="Drop Package"
                                value={dropPackage}
                                onChange={setDropPackage}
                            />
                            <TextField
                                fullWidth
                                label="Km"
                                type="number"
                                margin="normal"
                                value={kilometer}
                                onChange={(e) => setKiloMeter(e.target.value)}
                            />
                            <AmountInput sx={{ marginTop: '20px' }}
                                label="Amount"
                                value={amount}
                                onChange={setAmount}
                            />

                            <AmountInput sx={{ marginTop: '20px' }}
                                label="Add Km"
                                value={addKM}
                                onChange={setAddKM}
                            />

                            <AmountInput sx={{ marginTop: '20px' }}
                                label="Add Hours"
                                value={addHours}
                                onChange={setAddHours}
                            />

                        </>
                    )}

                    {packageType === 'common' && (
                        <>
                            <TextField
                                fullWidth
                                label="Km"
                                type="number"
                                margin="normal"
                                value={kilometer}
                                onChange={(e) => setKiloMeter(e.target.value)}
                            />
                            <AmountInput sx={{ marginTop: '20px' }}
                                label="Local Rate"
                                value={localRate}
                                onChange={setLocalRate}
                            />

                            <AmountInput sx={{ marginTop: '20px' }}
                                label="Package Extra km"
                                value={packageExtraKm}
                                onChange={setPackagExtraKm}
                            />
                        </>
                    )}

                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}  // Handle form submission
                        >
                            Submit {packageType === 'yercaud' ? 'Tour Package' : 'Trip'}
                        </Button>
                    </Box>
                </CardContent>
            </Card>
        );

    };

    return (
        <Container sx={{ marginBottom: 10 }} className='ride-booking-form'>
            <Typography variant="h4" align="center" gutterBottom>
                Teriff Form
            </Typography>

            {/* ToggleButtonGroup for selecting trip type */}
            <ToggleButtonGroup
                value={packageType}
                exclusive
                onChange={handleTripTypeChange}
                aria-label="Trip Type"
                sx={{ mb: 0 }}
            >
                <ToggleButton value="local" aria-label="Local Package">
                    Local Package
                </ToggleButton>
                <ToggleButton value="yercaud" aria-label="Yercaud Package">
                    Yercaud Package
                </ToggleButton>
                <ToggleButton value="common" aria-label="Common Package">
                    Common Package
                </ToggleButton>
            </ToggleButtonGroup>

            {/* Render the appropriate form based on selected trip type */}
            {renderForm()}
        </Container>
    );
};

export default TeriffPageForm;
